import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { WantPrice, SaveForLater, Postcode, Installers, ContactDetails, Thanks, RedirectToDGN, EmailUnpricedQuote } from "./QuoteForm";

class GetQuotePage extends Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route path="/GetQuote/WantPrice" component={WantPrice} />
                    <Route path="/GetQuote/RedirectToDGN" component={RedirectToDGN} />
                    <Route path="/GetQuote/EmailUnpricedQuote" component={EmailUnpricedQuote} />
                    <Route path="/GetQuote/SaveForLater" component={SaveForLater} />
                    <Route path="/GetQuote/Postcode" component={Postcode} />
                    <Route path="/GetQuote/Installers" component={Installers} />
                    <Route path="/GetQuote/ContactDetails" component={ContactDetails} />
                    <Route path="/GetQuote/Thanks" component={Thanks} />
                    <Redirect exact from="/GetQuote" to="/GetQuote/Postcode" />
                </Switch>
            </div>
        );
    }
}

export default GetQuotePage;



// WEBPACK FOOTER //
// ./src/containers/GetQuotePage.js